<div class="filter-input-element">
  <input
    *ngIf="![6, 7].includes(operator.operator)"
    nz-input
    type="number"
    [(ngModel)]="value"
    (blur)="onChange($event)"
  />
  <div class="double-input-filter" *ngIf="[6, 7].includes(operator.operator)">
    <input
      nz-input
      type="number"
      [(ngModel)]="firstValue"
      (blur)="onChange($event)"
      placeholder="From"
    />
    <input
      nz-input
      type="number"
      [(ngModel)]="secondValue"
      (blur)="onChange($event)"
      placeholder="To"
    />

    <p style="color: red" *ngIf="hasError">{{ errorMessage }}</p>
  </div>
</div>
